export type VisitorEntryPolicy = {
  pin_access_enabled?: boolean;
  guest_pin_access_enabled?: boolean;
  delivery_access_enabled?: boolean;
  face_access_enabled?: boolean;
};

export type IntercomEntryPolicy = {
  pin_access_enabled?: boolean | null;
  guest_pin_access_enabled?: boolean | null;
  face_access_enabled?: boolean | null;
};

export function showVisitorPinEntry(property: VisitorEntryPolicy | null, intercom: IntercomEntryPolicy): boolean {
  // "Show PIN pad" is the intercom-wide visibility switch. Guest and
  // delivery eligibility cannot bring the keypad back after it is turned off.
  if (intercom.pin_access_enabled === false) return false;
  return Boolean(
    property?.pin_access_enabled === true
    || (property?.guest_pin_access_enabled === true && intercom.guest_pin_access_enabled !== false)
    || property?.delivery_access_enabled === true,
  );
}

export function showVisitorFaceEntry(property: VisitorEntryPolicy | null, intercom: IntercomEntryPolicy): boolean {
  return property?.face_access_enabled === true && intercom.face_access_enabled !== false;
}
